var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import PerfectScrollbar from "perfect-scrollbar";
import { useEffect, useRef, } from "react";
import { useLogger } from "@/utils/loggerService";
export function ScrollContainer(_a) {
    var children = _a.children, className = _a.className, remainingAttrs = __rest(_a, ["children", "className"]);
    var logger = useLogger().logger;
    var ref = useRef(null);
    useEffect(function () {
        var sc = null;
        if (ref.current && !sc) {
            sc = new PerfectScrollbar(ref.current);
        }
        if (!ref.current && sc) {
            sc.destroy();
        }
        return function () {
            if (sc) {
                sc === null || sc === void 0 ? void 0 : sc.destroy();
            }
        };
    }, [ref.current]);
    return (_jsx("div", __assign({ ref: ref, className: "overflow-auto ".concat(className) }, remainingAttrs, { children: children })));
}
